import {Redirect, Route, useHistory, useLocation} from 'react-router-dom';
// eslint-disable-next-line no-unused-vars
import React, {Component, useEffect, useState} from "react";
import { decodeIdToken, getAccessToken } from "./authUtil";
import url from "./routeURL";
import ApiService from "../ApiService";
import useUserStore from "../hook/useUserStore";
import CircularProgress from "@material-ui/core/CircularProgress";


const AuthRoute = ({ component: Component, path, exact, ...rest }) => {
    const [loading, setLoading] = useState(true);
    const patient = useUserStore((state) => state.patient);
    const setPatient = useUserStore((state) => state.setPatient);
    const isAuth = useUserStore((state) => state.isAuth);
    const setIsAuth = useUserStore((state) => state.setIsAuth);
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        setLoading(true);
        const checkUserSignedIn = async () => {
            try {
                const accessToken = await getAccessToken();
                const decoded = decodeIdToken(accessToken);

                if (accessToken && decoded) {
                    if (isAuth !== true) setIsAuth(true);
                    const res = await ApiService.getPatientAfterSessRef();
                    setPatient(res.data);
                } else {
                    setIsAuth(false);
                    setPatient(null);
                }
            } catch (err) {
                setIsAuth(false);
                setPatient(null);
            } finally {
                setLoading(false);
            }
        };
        checkUserSignedIn();
    }, [path, Component]);

    const isHealthProfComplete = () => {
        return !!patient?.address?.region
            && !!patient?.dob?.trim()
            && !!patient?.gender?.trim()
            && !!patient?.genderAtBirth?.trim();
    }

    const isNonTbdUser = () => {
        return !patient?.email?.trim()?.endsWith('@tbd.health');
    }


    const renderFunc = (props, rest) => {
        if (loading){
            return <CircularProgress className="loading-button-spinner"/>;
        }
        if (isAuth && isNonTbdUser() && process.env.REACT_APP_ENV === 'sandbox') {
            window.location.href = "https://www.tbd.health/sign-in?redirect=patient-portal";
            return null;
          }
        if (!isAuth){
            const redirectTo = window.location.pathname + window.location.search;
            const loginUrl = `${url.login}?next=${redirectTo}`;
            return <Redirect to={loginUrl} {...rest} />;
        }
        //send actual component,
        // else it will create circular redirect. i.e: AuthRoute -> healthProfile Redirect -> AuthRoute
        if(path === url.healthProfile){
            return <Component {...props} {...rest} />;
        }
        //! Do not auto redirect to health profile if the user is not a patient, instead we have a different route for that
        // if (!isHealthProfComplete()){
        //     return <Redirect to={`${url.healthProfile}?next=${path}&missing-info=true`} {...props} {...rest} />;
        // }
        return <Component {...props} {...rest} />;
    };
    return (
        <Route
            path={path}
            exact={exact}
            render={props => renderFunc(props, rest)} />
    );
}

export default AuthRoute;
